import GBDKJS from "./gbdkjs";

// debugger;

window.g = new GBDKJS.GBDK();
window.uint = GBDKJS.uint;

export default window.g;



// WEBPACK FOOTER //
// ./src/gbdkjs-instance.js